import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

const styles = theme => ({
  button: {
    display: "block",
    marginTop: theme.spacing.unit * 2
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120
  }
});

class OpenSelect extends React.Component {
  state = {
    age: "",
    open: false
  };

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
    this.props.selectedVehicle(event.target.value);
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  render() {
    const { classes, uniqueVehicles } = this.props;
    return (
      <form autoComplete="off">
        <FormControl className={classes.formControl} style={{width:'230px'}}>
          <InputLabel htmlFor="demo-controlled-open-select">
            Select Vehicle
          </InputLabel>
          <Select
            open={this.state.open}
            onClose={this.handleClose}
            onOpen={this.handleOpen}
            value={this.state.age}
            onChange={this.handleChange}
            inputProps={{
              name: "age",
              id: "demo-controlled-open-select"
            }}
          >
            <MenuItem value="All">
              <em>All</em>
            </MenuItem>
            {uniqueVehicles.length !== 0
              ? uniqueVehicles.map(obj => (
                  <MenuItem value={obj.id}>{obj.customerVehicleId}</MenuItem>
                ))
              : null}
          </Select>
        </FormControl>
      </form>
    );
  }
}

OpenSelect.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(OpenSelect);



// WEBPACK FOOTER //
// ./src/views/Inspections/OpenSelect.js